import { render, staticRenderFns } from "./TemplateCases.vue?vue&type=template&id=61db333a&scoped=true&"
import script from "./TemplateCases.vue?vue&type=script&lang=js&"
export * from "./TemplateCases.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCases.vue?vue&type=style&index=0&id=61db333a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db333a",
  null
  
)

export default component.exports